import { render, staticRenderFns } from "./FieldAddDialog.vue?vue&type=template&id=2347ca33&scoped=true"
import script from "./FieldAddDialog.vue?vue&type=script&lang=js"
export * from "./FieldAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2347ca33",
  null
  
)

export default component.exports